export class Lager {
    public lager: string;
    public name1: string;
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/data/Lager.ts